"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UITag = _interopRequireDefault(require("UIComponents/tag/UITag"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _colors = require("HubStyleTokens/colors");

var AbsoluteFlex = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "CurrentPlanTag__AbsoluteFlex",
  componentId: "sc-10bab4d-0"
})(["position:absolute;"]);
var Tag = (0, _styledComponents.default)(_UITag.default).withConfig({
  displayName: "CurrentPlanTag__Tag",
  componentId: "sc-10bab4d-1"
})(["border-color:", ";border-top:0;border-right:0;"], _colors.BATTLESHIP);

var CurrentPlanTag = function CurrentPlanTag() {
  return _react.default.createElement(AbsoluteFlex, {
    justify: "end"
  }, _react.default.createElement(Tag, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.highlightedMerchCards.currentPlan"
  })));
};

var _default = CurrentPlanTag;
exports.default = _default;
module.exports = exports.default;